import Component from '@averyano/core/src/classes/Component';

export default class ProjectsSection extends Component {
	constructor() {
		super({
			element: '.projects',
			elements: {
				showMoreBtn: '.projects__overlay-btn',
			},
		});
	}

	create() {
		super.createComponent();
	}

	showMore() {
		this.element.classList.add('is-expanded');
	}

	addEventListeners() {
		if (!this.elements.showMoreBtn) return;

		this.onShowMoreClick = () => this.showMore();
		this.elements.showMoreBtn.addEventListener('click', this.onShowMoreClick);
	}

	removeEventListeners() {
		if (!this.elements.showMoreBtn) return;

		this.elements.showMoreBtn.removeEventListener('click', this.onShowMoreClick);
	}

	destroy() {
		this.removeEventListeners();
		super.destroy();
	}
}
